import { z } from 'zod'

/** Login request body. Shared so the web form and the API validate identically. */
export const loginInputSchema = z
  .object({
    email: z.string().trim().toLowerCase().email(),
    password: z.string().min(1, 'Password is required').max(128),
  })
  .strict()

export type LoginInput = z.infer<typeof loginInputSchema>
